export { getStoresAppDefId, getEcomAppDefId } from './getAppDefId';
